import React, { useState, useEffect } from 'react';
import axios from 'axios';

function AdminTokenAdjuster() {
  const [userIdToAdjust, setUserIdToAdjust] = useState('');
  const [amount, setAmount] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [filter, setFilter] = useState('');
  const [sortBy, setSortBy] = useState('id'); // 'id', 'username', or 'email'
  const [sortOrder, setSortOrder] = useState('asc'); // 'asc' or 'desc'

  // Fetch users on mount
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/admin/users`, // <-- updated
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        setUsers(response.data);
      } catch (err) {
        // Removed console.log for production
      }
    };
    if (showTable) fetchUsers();
  }, [showTable]);

  // Sorting logic
  const sortedUsers = [...users]
    .filter(user =>
      user.username.toLowerCase().includes(filter.toLowerCase()) ||
      user.email.toLowerCase().includes(filter.toLowerCase()) ||
      user.id.toString().includes(filter)
    )
    .sort((a, b) => {
      let valA = a[sortBy];
      let valB = b[sortBy];
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return sortOrder === 'asc' ? -1 : 1;
      if (valA > valB) return sortOrder === 'asc' ? 1 : -1;
      return 0;
    });

  const handleSubmitAdjustment = async (e) => {
    e.preventDefault();

    // Basic frontend validation
    if (!userIdToAdjust || !amount) {
      setError('Please enter both User ID and Amount.');
      return;
    }

    const userId = parseInt(userIdToAdjust); // Convert to integer
    const tokenAmount = parseInt(amount); // Convert to integer

    if (isNaN(userId) || isNaN(tokenAmount)) {
       setError('User ID and Amount must be numbers.');
       return;
    }

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('Admin user not authenticated.');
        return;
      }
      setMessage('Adjusting tokens...');
      setError(null);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/admin/adjust-tokens`, // <-- updated
        {
          userIdToAdjust: userId,
          amount: tokenAmount,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setMessage(response.data.message);
      setUserIdToAdjust('');
      setAmount('');
    } catch (err) {
      setError(err.response.data.error || 'Error adjusting tokens.');
      setMessage('');
    }
  };

  return (
    <div className="test-body">
      <h2 id="adminh2">Adjust User Tokens (Admin)</h2>
      <form className="tokens-form" onSubmit={handleSubmitAdjustment}>
        <div className="form-group">
          <label htmlFor="userIdToAdjust" className="label-group" id="admin-user-id">User ID:</label>
          <input className="field-groups"
            type="number" // Use number type for input
            id="userIdToAdjust"
            value={userIdToAdjust}
            onChange={(e) => setUserIdToAdjust(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="amount" className="label-group" id="admin-amount">Amount:</label>
          <input className="field-groups"
            type="number" // Use number type for input
            id="amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>
        <button type="submit" id="adjtokens">Add</button>
      </form>
      <button
        type="button"
        id ="show-users-button"
        onClick={() => setShowTable(!showTable)}
        style={{ margin: '20px 0' }}
      >
        {showTable ? 'Hide Users' : 'Show Users'}
      </button>

      {showTable && (
        <div>
          <input
            type="text"
            placeholder="Filter by ID, username, or email"
            value={filter}
            onChange={e => setFilter(e.target.value)}
            style={{ marginBottom: '10px' }}
          />
          <div className="admin-sort-buttons">
            <button onClick={() => {
              setSortBy('id');
              setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
            }}>
              Sort by ID {sortBy === 'id' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </button>
            <button onClick={() => {
              setSortBy('username');
              setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
            }}>
              Sort by Username {sortBy === 'username' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </button>
            <button onClick={() => {
              setSortBy('email');
              setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
            }}>
              Sort by Email {sortBy === 'email' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </button>
          </div>
          <table className="admin-table" border="1" style={{ width: '100%', marginTop: '10px' }}>
            <thead>
              <tr>
                <th>User ID</th>
                <th>Username</th>
                <th>Email</th>
                <th>Tokens</th>
              </tr>
            </thead>
            <tbody>
              {sortedUsers.map(user => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.username}</td>
                  <td>{user.email}</td>
                  <td>{user.tokens}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {message && <p style={{ color: 'green' }}>{message}</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
}

export default AdminTokenAdjuster;
